import { useState, useEffect } from "react";
import "./styles.css";

export default function App() {
  const [orders, setOrders] = useState([]);
  const [inventory, setInventory] = useState({});
  const [recipes, setRecipes] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    fetchInventory();
    fetchRecipes();
  }, []);

  const fetchInventory = async () => {
    try {
      const res = await fetch('https://prueba-alegra-production.up.railway.app/inventory');
      const data = await res.json();
      
      if (data.cocinaResponse) {
        setInventory(data.cocinaResponse);
      } else {
        setInventory({});
      }
    } catch (error) {
      console.error("Error fetching inventory:", error);
    }
  };

  const fetchRecipes = async () => {
    try {
      const res = await fetch('https://cocina-service-production.up.railway.app/recipes');
      if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
      const data = await res.json();
      setRecipes(data);
    } catch (error) {
      console.error("Error fetching recipes:", error);
    }
  };

  const placeOrder = async () => {
    setLoading(true);
    setErrorMessage("");
    
    try {
      const res = await fetch('https://prueba-alegra-production.up.railway.app/new-order', { method: "POST" });
      const data = await res.json();

      if (data.status === "espera") {
        setErrorMessage("No se puede completar el pedido: ingredientes no disponibles.");
        setLoading(false);
        return;
      }

      setOrders(prevOrders => [...prevOrders, data]);

      setTimeout(() => {
        setOrders(prevOrders => prevOrders.filter(order => order.orderId !== data.orderId));
        setOrderHistory(prevHistory => [...prevHistory, data]);
      }, 2000);
    } catch (error) {
      console.error("Error al realizar el pedido:", error);
    }

    setLoading(false);
  };

  return (
    <div className="container">
      <div className="corner-text">ALEGRA</div>
      <h1>Jornada de donación de comidas</h1>
      {errorMessage && <p className="error-message" style={{ color: "red", fontWeight: "bold", backgroundColor: "#ffcccc", padding: "10px", borderRadius: "5px" }}>{errorMessage}</p>}
      <button onClick={placeOrder} disabled={loading}>
        {loading ? "Procesando..." : "Pedir un Plato"}
      </button>

      <div className="lists-container">
        <div className="list-section">
          <h2>Órdenes en preparación</h2>
          <ul className="order-list">
            {orders.map((order, index) => (
              <li key={index}>
                {order.orderId}
                <span className="order-status"> pending</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="list-section">
          <h2>Inventario de Bodega</h2>
          <ul className="inventory-list">
            {Object.entries(inventory).map(([ingredient, qty]) => (
              <li key={ingredient}>
                {ingredient}: {qty}
              </li>
            ))}
          </ul>
        </div>

        <div className="list-section">
          <h2>Recetas Disponibles</h2>
          <ul className="recipes-list">
            {recipes.map((recipe, index) => (
              <li key={index}>
                <strong>{recipe.name}</strong>: {recipe.ingredients
                  ? Object.entries(recipe.ingredients)
                      .map(([ing, qty]) => `${ing} (${qty})`)
                      .join(", ")
                  : "No ingredients available"}
              </li>
            ))}
          </ul>
        </div>

        <div className="list-section">
          <h2>Historial de Pedidos</h2>
          <ul className="history-list">
            {orderHistory.map((order, index) => (
              <li key={index}>
                {order.orderId} - {order.status}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
